module.exports = __webpack_public_path__ + "static/vroomsquad-2aa56301163d1432fef68753764e4741.png";